import { Link } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { blueprintsApi } from '../api/blueprints.js';
import { VazioQueEnsina } from '../componentes/transversais/VazioQueEnsina.js';

// SPEC-UX §4.3 — catálogo por tipo de iniciativa; card mostra versão
// vigente e leva à tela de detalhe (editor de fases em rascunho + diff
// entre versões, em BlueprintDetalhe.tsx).
export function Blueprints() {
  const queryClient = useQueryClient();
  const { data: blueprints, isLoading } = useQuery({ queryKey: ['blueprints'], queryFn: () => blueprintsApi.listarPublicados() });

  const clonar = useMutation({
    mutationFn: (id: string) => blueprintsApi.clonar(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['blueprints'] }),
  });

  return (
    <div className="flex flex-col gap-6 p-8">
      <h1 className="text-xl font-semibold text-ink">Blueprints</h1>

      {isLoading && <p className="text-sm text-grafite">Carregando…</p>}

      {!isLoading && (!blueprints || blueprints.length === 0) && (
        <VazioQueEnsina explicacao="Nenhum blueprint publicado. Projetos nascem de blueprints — crie o primeiro pela API ou por importação." />
      )}

      {blueprints && blueprints.length > 0 && (
        <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {blueprints.map((blueprint) => (
            <li key={blueprint.id} className="rounded-lg border border-borda bg-superficie p-4">
              <Link to={`/blueprints/${blueprint.id}`} className="block hover:text-aco">
                <p className="text-sm font-medium text-ink">{blueprint.nome}</p>
                <p className="fonte-mono text-xs text-grafite">
                  v{blueprint.versao} · {blueprint.tipoIniciativa}
                </p>
              </Link>
              <button
                type="button"
                onClick={() => clonar.mutate(blueprint.id)}
                disabled={clonar.isPending}
                className="mt-3 rounded border border-aco px-3 py-1.5 text-xs font-medium text-aco hover:bg-aco/5 disabled:opacity-50"
              >
                Criar nova versão
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
